export default __webpack_public_path__ + "static/media/Mask Group 48.e0f8dddd.png";